// components/CuisineTypes.tsx
import React from "react";

type CuisineTypesProps = {
  types: string[];
};

const CuisineTypes: React.FC<CuisineTypesProps> = ({ types }) => {
  if (!types?.length) {
    return <></>;
  }
  return (
    <div className="flex items-center flex-wrap">
      {types.map((type: string, index: number) => {
        return (
          <a
            href={`/restaurants/cuisine/${type.toLocaleLowerCase()}/`}
            key={index}
            className="bg-[#e5e5e5] px-1 py-1 mx-1 mb-2 text-[10px] border rounded-sm"
          >
            {type}
          </a>
        );
      })}
    </div>
  );
};

export default CuisineTypes;
